/* eslint-disable camelcase */
import * as THREE from 'three'
import { drawRingStanding } from './drawRingStanding'
import { drawRectStanding } from './drawRectStanding'
import { drawOvalStanding } from './drawOvalStanding'
import { drawMultipleRects } from './drawMultipleRects'
import { SEAT_GROUP_TYPES, SEAT_STATUSES, COLORS } from '../constants'
import { getLineMaterial, getSeatMaterial } from '../utils/helper_functions'
import { materials, standingAreas } from '../utils/mapData'

export const drawStandingArea = (group, options) => {
  const {
    color,
    scale,
    scene,
    center_x,
    center_y,
    events,
    tierId,
    label,
    enableTicketTypeAssign,
    tierColor,
    selectedTierId,
    id: sgId,
    sceneMeshes
  } = options

  let { opacity } = options

  const seatColor = enableTicketTypeAssign ? tierColor : COLORS.BOOKED

  if (selectedTierId && selectedTierId !== tierId) {
    opacity = 0.3
  }

  let drawingFn
  switch (group.standingAreaShape) {
    case 'ring':
      drawingFn = drawRingStanding
      break
    case 'rect':
      drawingFn = drawRectStanding
      break
    case 'oval':
      drawingFn = drawOvalStanding
      break
    case 'multiple_rects':
      drawingFn = drawMultipleRects
      break
  }
  const { standingArea, rectMeshes } = drawingFn(group, {
    ...options,
    color: seatColor,
    opacity
  })

  Object.defineProperty(standingArea, 'material', {
    get: function () {
      return rectMeshes[0].material
    }
  })

  standingArea.position.set(-center_x * scale, center_y * scale, 0)
  scene.add(standingArea)

  standingArea.click = events.onClick
  standingArea.mouseOver = events.onMouseOver
  standingArea.mouseOut = events.onMouseOut

  standingArea.sgType = SEAT_GROUP_TYPES.STANDING
  standingArea.sgId = sgId
  standingArea.sgLabel = label
  standingArea.tierId = tierId
  standingArea.status = SEAT_STATUSES.BOOKED
  standingArea.sectionLabel = label
  standingArea.rowLabel = label
  standingArea.label = label
  standingArea.opacity = opacity
  standingArea.color = seatColor

  if (group.rotation) {
    const degree = (group.rotation * Math.PI) / 180
    standingArea.rotateOnAxis(new THREE.Vector3(0, 0, 1), degree)
  }

  standingArea.changeBorderColor = (color) => {
    standingArea.borderLines &&
      standingArea.borderLines.forEach((line) => {
        line.material = getLineMaterial({ color }, materials)
      })
  }

  standingArea.changeBorderColorToDefault = () =>
    standingArea.changeBorderColor(color)
  const makeAvailable = () => {
    standingArea.changeBorderColor(color)

    rectMeshes.forEach((rect) => {
      rect.material = getSeatMaterial({ color }, materials)
    })
    standingArea.status = SEAT_STATUSES.AVAILABLE
    standingArea.click = events.onClick
    standingArea.changeBorderColorToDefault = () =>
      standingArea.changeBorderColor(color)
  }

  standingArea.changeOpacity = (opacity, color) => {
    standingArea.children[0].material = getSeatMaterial(
      { color, opacity },
      materials
    )
  }

  const makeBooked = () => {
    standingArea.changeBorderColor(COLORS.BOOKED)

    rectMeshes.forEach((rect) => {
      rect.material = getSeatMaterial({ color: COLORS.BOOKED }, materials)
    })
    standingArea.status = SEAT_STATUSES.BOOKED
    standingArea.click = null
    standingArea.changeBorderColorToDefault = () =>
      standingArea.changeBorderColor(COLORS.BOOKED)
  }

  const makeBlocked = () => {
    standingArea.changeBorderColor(COLORS.BLOCKED)

    rectMeshes.forEach((rect) => {
      rect.material = getSeatMaterial({ color: COLORS.BLOCKED }, materials)
    })
    standingArea.status = SEAT_STATUSES.BLOCKED
    standingArea.click = null
    standingArea.changeBorderColorToDefault = () =>
      standingArea.changeBorderColor(COLORS.BLOCKED)
  }

  standingArea.statusUpdate = (status) => {
    if (standingArea.status !== status) {
      switch (status) {
        case SEAT_STATUSES.AVAILABLE: {
          makeAvailable()
          break
        }
        case SEAT_STATUSES.BOOKED: {
          makeBooked()
          break
        }
        case SEAT_STATUSES.BLOCKED: {
          makeBlocked()
          break
        }
      }
    }
  }
  standingArea.hasHandlers = true
  standingArea.changeOpacity(opacity, seatColor)
  sceneMeshes.push(standingArea)
  standingAreas.push(standingArea)
}
